// extracted by mini-css-extract-plugin
module.exports = {"categories":"ReferenceCategories-module--categories--160K6"};